import {
	BUILDING_COMPONENT,
	LIVE_SEARCH_LOADING,
	INPUT_SWAP_QUOTE_LOADING,
	ITEM_DELETING,
	FETCHING_DATA_FROM_API,
	SENDING_TRANSACTION,
	UPDATING_DATA,
	BUILDING_APP,
} from "helpers/constants";

export const FetchingDataFromApi = (loading = false, action) => {
	switch (action.type) {
		case FETCHING_DATA_FROM_API:
			return action.payload;

		default:
			return loading;
	}
};

export const SendingTransaction = (loading = false, action) => {
	switch (action.type) {
		case SENDING_TRANSACTION:
			return action.payload;

		default:
			return loading;
	}
};

export const BuildingComponent = (loading = false, action) => {
	switch (action.type) {
		case BUILDING_COMPONENT:
			return action.payload;

		default:
			return loading;
	}
};

export const BuildingApp = (loading = true, action) => {
	switch (action.type) {
		case BUILDING_APP:
			return action.payload;

		default:
			return loading;
	}
};

export const UpdatingData = (loading = false, action) => {
	switch (action.type) {
		case UPDATING_DATA:
			return action.payload;

		default:
			return loading;
	}
};

export const LiveSearchLoading = (loading = false, action) => {
	switch (action.type) {
		case LIVE_SEARCH_LOADING:
			return action.payload;

		default:
			return loading;
	}
};

export const InputSwapQuoteLoading = (loading = false, action) => {
	switch (action.type) {
		case INPUT_SWAP_QUOTE_LOADING:
			return action.payload;

		default:
			return loading;
	}
};
